import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Field, reduxForm } from 'redux-form'
import FormHelperText from '@material-ui/core/FormHelperText'
import Typography from '@material-ui/core/Typography'
import withStyles from '@material-ui/core/styles/withStyles'
import Input from '@material-ui/core/Input'
import Button from '@material-ui/core/Button'
import LinearProgress from '@material-ui/core/LinearProgress'
import CheckIcon from 'react-icons/lib/io/android-checkmark-circle'
import compose from 'recompose/compose'
import { sendAlert, subscribe } from 'actions/app'
import regexp from 'utils/regexp'

const styles = (theme) => ({
  form: {
    position: 'relative',
    '&::after': {
      clear: 'both',
    },
  },
  field: {
    margin: 'auto',
    maxWidth: '70%',
    [theme.breakpoints.down('xs')]: {
      maxWidth: '100%',
    },
  },
  helperText: {
    fontSize: '0.9em',
    marginBottom: 6,
    textAlign: 'center',
  },
  input: {
    float: 'left',
    width: '50%',
    padding: '0 5px',
    fontWeight: 500,
    background: theme.palette.borders.ghost,
    '& input': {
      textAlign: 'center',
      fontWeight: 400,
    },
    '& input::placeholder': {
      fontSize: '0.9em',
      textAlign: 'center',
      fontWeight: 500,
      color: '#000',
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  buttonWrapper: {
    float: 'right',
    width: '50%',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  button: {
    fontWeight: 400,
    background: theme.palette.accent.notice,
    color: '#fff',
    boxShadow: 'none',
    borderRadius: 1,
    width: '100%',
    '&:hover': {
      color: '#000',
    },
  },
  successText: {
    clear: 'both',
    width: '100%',
    fontWeight: 500,
    color: theme.palette.text.main,
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.8em',
    },
  },
  checkIcon: {
    color: theme.palette.successLighter,
    fontSize: '2.5em',
  },
})

const renderInput = ({ input, meta: { touched, error }, ...customProps }) => (
  <Fragment>
    <Input error={touched && !!error} {...input} {...customProps} />
  </Fragment>
)

const AboutSubscribeForm = ({
  classes,
  submitting,
  handleSubmit,
  submitSucceeded,
}) => {
  const actionProps = {}
  let oldBrowser = false

  if (
    typeof Promise !== 'undefined' &&
    Promise.toString().indexOf('[native code]') !== -1
  ) {
    actionProps.onSubmit = handleSubmit
  } else {
    oldBrowser = true
    actionProps.action = process.env.SUBSCRIBE_URL
    actionProps.method = 'post'
  }

  return (
    <form
      style={{ opacity: submitting ? 0.4 : 1 }}
      className={classes.form}
      {...actionProps}
    >
      <LinearProgress
        color="secondary"
        style={{
          position: 'relative',
          width: '100%',
          marginBottom: 5,
          display: submitting ? 'block' : 'none',
        }}
      />
      {!submitSucceeded && (
        <div className={classes.field}>
          <FormHelperText className={classes.helperText}>
            Simply enter your email and click SUBSCRIBE
          </FormHelperText>
          {!oldBrowser && (
            <Field
              classes={{ root: classes.input }}
              name="email"
              placeholder="EMAIL"
              component={renderInput}
              type="email"
              disableUnderline
              fullWidth
              required
            />
          )}
          {oldBrowser && (
            <div className={classes.input}>
              <Input
                name="email"
                placeholder="EMAIL"
                type="email"
                disableUnderline
                fullWidth
                required
              />
            </div>
          )}
          {oldBrowser && (
            <input
              type="hidden"
              name="thankyou_url"
              value={window.location.href}
            />
          )}
          <input type="hidden" name="campaign_token" value="6qdpg" />
          <div className={classes.buttonWrapper}>
            <Button
              classes={{ root: classes.button }}
              variant="raised"
              type="submit"
              size="small"
            >
              <Typography variant="button" style={{ color: '#fff' }}>
                Subscribe
              </Typography>
            </Button>
          </div>
        </div>
      )}
      {submitSucceeded && (
        <Typography align="center" className={classes.successText}>
          <CheckIcon className={classes.checkIcon} /> Thank you, you're all set.<br />
        </Typography>
      )}
    </form>
  )
}

AboutSubscribeForm.propTypes = {
  classes: PropTypes.object.isRequired,
  subscribe: PropTypes.func.isRequired,
  sendAlert: PropTypes.func.isRequired,
}

export default compose(
  withStyles(styles),
  connect(null, { subscribe, sendAlert }),
  reduxForm({
    form: 'SubscribeFormInAboutPage',
    onSubmit: (
      { email },
      _,
      { subscribe: subscribeUser, reset, sendAlert },
    ) => {
      return new Promise((resolve, reject) => {
        let errorMsg
        if (!email) {
          errorMsg = 'Please provide your email.'
        }
        if (!regexp.email.test(email)) {
          errorMsg = 'Please provide a valid email.'
        }

        if (errorMsg) {
          reject(
            sendAlert({
              type: 'error',
              message: errorMsg,
            }),
          )
        } else {
          subscribeUser({ campaignToken: '6qdpg', email })
            .then(() => {
              sendAlert({
                message: "You're now subscribed!",
                type: 'success',
              })
              resolve(reset())
            })
            .catch(() =>
              reject(
                sendAlert({
                  message:
                    'The email is either already registered or an error occurred. Please try again later.',
                  type: 'error',
                }),
              ),
            )
        }
      })
    },
  }),
)(AboutSubscribeForm)



// WEBPACK FOOTER //
// ./src/components/forms/AboutSubscribeForm.js